import { render, staticRenderFns } from "./VisitasFormulario.vue?vue&type=template&id=336d6f82&scoped=true"
import script from "./VisitasFormulario.vue?vue&type=script&lang=js"
export * from "./VisitasFormulario.vue?vue&type=script&lang=js"
import style0 from "./VisitasFormulario.vue?vue&type=style&index=0&id=336d6f82&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "336d6f82",
  null
  
)

export default component.exports